import { z } from 'zod';
import { DataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';

export const FullHiringCopilotDefinition = z
  .object({
    copilotType: z.literal('hiring'),
    externalPayBenchmarkingReference: DataSetReference.optional(),
  })
  .describe('FullHiringCopilotDefinition');

export type FullHiringCopilotDefinition = z.infer<
  typeof FullHiringCopilotDefinition
>;

// We exclude any fields here that are data set references, since they cause a cache miss on the dependency due to the schema changing.
export const HiringCopilotDefinition = FullHiringCopilotDefinition.omit({
  externalPayBenchmarkingReference: true,
}).describe('HiringCopilotDefinition');

export type HiringCopilotDefinition = z.infer<typeof HiringCopilotDefinition>;
